export const isRussianMarket = (locale: string): boolean => locale.split('_')[1] === 'RU';
